<template>
    <span class="invalid-feedback d-block" role="alert">
        <ul class="mb-0 list-unstyled">
            <li v-for="(message, index) in errors" :key="index">
                {{ message }}
              </li>
        </ul>
    </span>
</template>

<script>
export default ({
    props: {
        errors: Array
    }
})
</script>